module.exports = __webpack_public_path__ + "static/media/phone2.b2dcbc6c.png";